export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 32 32" className={className} fill="none" aria-hidden="true">
    <rect width="32" height="32" rx="8" fill="#0B2B1D" />
    <path d="M15 24c-4.5-2.6-6-6.2-6-9 0-3.4 2.4-7 8-10 1.2 2.2 2 4.6 2 7 0 4.4-1.6 8.6-4 12z" fill="#22C55E" />
    <path d="M23 7l.9 2.1L26 10l-2.1.9L23 13l-.9-2.1L20 10l2.1-.9z" fill="#DCFCE7" />
  </svg>
);

export const Logo = ({ dark = false }) => (
  <span className="flex items-center gap-2.5">
    <LogoMark />
    <span className={`font-display font-extrabold tracking-tight text-lg leading-none ${dark ? "text-forest" : "text-white"}`}>
      GLOW<span className="text-leaf"> GREEN</span>
    </span>
  </span>
);
